import { useMutation, useQueryClient } from '@tanstack/react-query';

interface BulkSuggestJobPostsParams {
  jobPostIds: number[];
  candidateProfileIds: number[];
}

// 求人 × 求職者の総当たり提案を1リクエストで行う (Issue #3426)
export default function useBulkSuggestJobPosts() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ jobPostIds, candidateProfileIds }: BulkSuggestJobPostsParams) => {
      const response = await fetch('/agent/api/job_post_endpoints/bulk_insert.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token':
            document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        },
        body: JSON.stringify({
          provided_job_post_ids: jobPostIds,
          candidate_profile_ids: candidateProfileIds,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || '求人の提案に失敗しました');
      }

      return response.json();
    },
    onSuccess: (_, { jobPostIds }) => {
      jobPostIds.forEach((jobPostId) => {
        queryClient.invalidateQueries({ queryKey: ['suggestedCandidates', jobPostId] });
        queryClient.invalidateQueries({ queryKey: ['providedJobPost', jobPostId] });
      });
    },
  });
}
